import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { black } from '@avangard/ui/colors';

import contentEmpty from '@modules/subjects/lectures/helpers/assets/content-empty.svg';

const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: flex-start;
    justify-content: center;
    width: 100%;
    height: 100%;
    text-align: center;
`;

const Inner = styled.div`
    max-width: 530px;
    text-align: center;
`;

const Image = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 32px auto;
    width: 270px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;

const Title = styled.p`
    color: ${black[100]};
    font-size: 2rem;
    font-weight: 600;
    line-height: 1.4;
`;

const LectureEmpty = (): React.ReactElement => {
    const { t } = useTranslation(['subjects']);

    return (
        <Root>
            <Inner>
                <Image>
                    <img src={contentEmpty} alt='content-lecture-empty' />
                </Image>

                <Title>{t('subjects:stubs.empty_subject')}</Title>
            </Inner>
        </Root>
    );
};

export { LectureEmpty };
